import { motion } from "framer-motion";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useLockScreenFocus } from "@/hooks/useLockScreenFocus";

/**
 * Lock Screen Nudges toggle row. Global On/Off can only be turned ON by
 * pinning a task via a card's lock icon, so the toggle here is a signal
 * + off-switch, not a direct on-switch.
 */
export const LockScreenNudgeRow = ({ isAuthenticated, onClose }) => {
  const lockScreen = useLockScreenFocus();

  const handleToggle = async () => {
    if (lockScreen.status.enabled) {
      await lockScreen.disable();
      return;
    }
    if (!isAuthenticated) {
      toast("Sign in to enable Lock Screen Nudges.", { duration: 3500 });
      return;
    }
    toast("Tap the lock icon on any task to make it your Lock Screen focus.", {
      duration: 4000,
      icon: '🔒',
    });
    onClose();
  };

  return (
    <div className="flex items-center justify-between p-4 bg-[#FDFBF7] rounded-xl">
      <div className="flex items-center gap-3">
        <Lock size={20} className={lockScreen.status.enabled ? "text-[#0CBCBF]" : "text-stone-400"} />
        <div>
          <p className="font-medium text-[#27272A]">Lock Screen Nudges</p>
          <p className="text-xs text-[#A1A1AA]">
            {lockScreen.status.enabled && lockScreen.status.taskName
              ? `Focused on: ${lockScreen.status.taskName}`
              : !isAuthenticated
                ? "Sign in, then tap the lock icon on a task"
                : "Tap the lock icon on a task to turn on"}
          </p>
        </div>
      </div>
      <button
        onClick={handleToggle}
        data-testid="lockscreen-global-toggle"
        disabled={lockScreen.status.loading}
        className={`w-12 h-7 rounded-full transition-colors ${
          lockScreen.status.enabled ? "bg-[#0CBCBF]" : "bg-stone-300"
        } disabled:opacity-50 disabled:cursor-not-allowed`}
        title={lockScreen.status.enabled ? "Tap to turn off" : "Tap for how-to"}
      >
        <motion.div
          className="w-5 h-5 bg-white rounded-full shadow-sm"
          animate={{ x: lockScreen.status.enabled ? 22 : 4 }}
          transition={{ type: "spring", stiffness: 500, damping: 30 }}
        />
      </button>
    </div>
  );
};

export default LockScreenNudgeRow;
